import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AutoSteeringHeroSection from './components/AutoSteeringHeroSection';
import AutoSteeringLineupSection from './components/AutoSteeringLineupSection';
import ManufacturerSection from './components/ManufacturerSection';
import ComparisonTableSection from './components/ComparisonTableSection';
import CTASection from '../home/components/CTASection';
import { useSEO, generateOrganizationSchema, generateWebPageSchema } from '../../utils/seoUtils';

export default function AutoSteering() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const seoData = {
    title: 'FJD・EFIX自動操舵システム販売｜RTK±2.5cm精度｜佐賀・福岡・鹿児島｜IDS教習所',
    description: 'FJDynamics・EFIX自動操舵システム正規販売店。FJD AT2 Max（12.1インチ・0.5-26km/h）、FJD AT2（10.1インチ・コスト重視）、FJD AL02（レベリング専用）、FJD ATS（散布専用）、eSteer 20 MAX（12インチ・ISOBUS対応・0.1-30km/h）、eSteer 20（10インチ・入門向け）。全機種RTK±2.5cm高精度測位。佐賀・福岡・鹿児島IDS教習所。無料相談受付中。',
    keywords: '自動操舵システム,FJDynamics,FJD AT2 Max,FJD AT2,FJD AL02,FJD ATS,EFIX,eSteer 20 MAX,eSteer 20,RTK測位,RTK±2.5cm,ISOBUS,トラクター自動運転,精密農業,スマート農業,レベリングシステム,精密散布,佐賀県,福岡県,鹿児島県,IDS教習所,大規模農業,水田農家,畑作農家',
    canonical: `${siteUrl}/auto-steering`,
    structuredData: {
      "@context": "https://schema.org",
      "@graph": [
        generateOrganizationSchema(),
        generateWebPageSchema(
          'FJD・EFIX自動操舵システム販売｜RTK±2.5cm精度｜佐賀・福岡・鹿児島｜IDS教習所',
          'FJDynamics・EFIX自動操舵システム正規販売店。FJD AT2 Max（12.1インチ・0.5-26km/h）、FJD AT2（10.1インチ・コスト重視）、FJD AL02（レベリング専用）、FJD ATS（散布専用）、eSteer 20 MAX（12インチ・ISOBUS対応・0.1-30km/h）、eSteer 20（10インチ・入門向け）。全機種RTK±2.5cm高精度測位。佐賀・福岡・鹿児島IDS教習所。無料相談受付中。',
          `${siteUrl}/auto-steering`
        ),
        {
          "@type": "CollectionPage",
          "name": "自動操舵システム",
          "description": "RTK±2.5cm精度の高精度自動操舵システム。FJDynamicsとEFIXの6モデルから最適なシステムをご提案",
          "url": `${siteUrl}/auto-steering`,
          "mainEntity": {
            "@type": "ItemList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "item": {
                  "@type": "Product",
                  "name": "FJD AT2 Max",
                  "description": "12.1インチモニター・RTK±2.5cm精度・0.5-12km/h対応(0.1km/hオプション)・ISOBUS対応。大規模農場向け。価格お問い合わせ。",
                  "brand": {
                    "@type": "Brand",
                    "name": "FJDynamics"
                  },
                  "image": "https://ids-group.jp/images/fjd-at2-max.jpg",
                  "offers": {
                    "@type": "Offer",
                    "price": 0,
                    "priceCurrency": "JPY",
                    "priceValidUntil": "2026-12-31",
                    "availability": "https://schema.org/InStock",
                    "seller": {
                      "@type": "Organization",
                      "name": "IDS教習所グループ",
                      "url": "https://ids-group.jp",
                      "telephone": "+81952719855"
                    }
                  }
                }
              },
              {
                "@type": "ListItem",
                "position": 2,
                "item": {
                  "@type": "Product",
                  "name": "FJD AT2",
                  "description": "10.1インチモニター・RTK±2.5cm精度・0.5-12km/h対応(0.1km/hオプション)・ISOBUS対応。中規模農場向け。価格お問い合わせ。",
                  "brand": {
                    "@type": "Brand",
                    "name": "FJDynamics"
                  },
                  "image": "https://ids-group.jp/images/fjd-at2.jpg",
                  "offers": {
                    "@type": "Offer",
                    "price": 0,
                    "priceCurrency": "JPY",
                    "priceValidUntil": "2026-12-31",
                    "availability": "https://schema.org/InStock",
                    "seller": {
                      "@type": "Organization",
                      "name": "IDS教習所グループ",
                      "url": "https://ids-group.jp",
                      "telephone": "+81952719855"
                    }
                  }
                }
              },
              {
                "@type": "ListItem",
                "position": 3,
                "item": {
                  "@type": "Product",
                  "name": "FJD AL02",
                  "description": "10.1インチモニター・RTK±2.5cm精度・レベリング専用設計・ISOBUS対応。水田農家・圃場整備事業者向け。価格お問い合わせ。",
                  "brand": {
                    "@type": "Brand",
                    "name": "FJDynamics"
                  },
                  "image": "https://ids-group.jp/images/fjd-al02.jpg",
                  "offers": {
                    "@type": "Offer",
                    "price": 0,
                    "priceCurrency": "JPY",
                    "priceValidUntil": "2026-12-31",
                    "availability": "https://schema.org/InStock",
                    "seller": {
                      "@type": "Organization",
                      "name": "IDS教習所グループ",
                      "url": "https://ids-group.jp",
                      "telephone": "+81952719855"
                    }
                  }
                }
              },
              {
                "@type": "ListItem",
                "position": 4,
                "item": {
                  "@type": "Product",
                  "name": "FJD ATS",
                  "description": "10.1インチモニター・RTK±2.5cm精度・0.5-12km/h対応(0.1km/hオプション)・スプレーヤー専用・ISOBUS対応。大規模畑作農家向け。価格お問い合わせ。",
                  "brand": {
                    "@type": "Brand",
                    "name": "FJDynamics"
                  },
                  "image": "https://ids-group.jp/images/fjd-ats.jpg",
                  "offers": {
                    "@type": "Offer",
                    "price": 0,
                    "priceCurrency": "JPY",
                    "priceValidUntil": "2026-12-31",
                    "availability": "https://schema.org/InStock",
                    "seller": {
                      "@type": "Organization",
                      "name": "IDS教習所グループ",
                      "url": "https://ids-group.jp",
                      "telephone": "+81952719855"
                    }
                  }
                }
              },
              {
                "@type": "ListItem",
                "position": 5,
                "item": {
                  "@type": "Product",
                  "name": "eSteer 20 MAX",
                  "description": "12インチモニター・RTK±2.5cm精度・0.1-30km/h対応・ISOBUS(VT/TC-SC/TC-GEO)対応・SkyTrix対応。大規模経営向け。価格お問い合わせ。",
                  "brand": {
                    "@type": "Brand",
                    "name": "EFIX"
                  },
                  "image": "https://ids-group.jp/images/esteer-20-max.jpg",
                  "offers": {
                    "@type": "Offer",
                    "price": 0,
                    "priceCurrency": "JPY",
                    "priceValidUntil": "2026-12-31",
                    "availability": "https://schema.org/InStock",
                    "seller": {
                      "@type": "Organization",
                      "name": "IDS教習所グループ",
                      "url": "https://ids-group.jp",
                      "telephone": "+81952719855"
                    }
                  }
                }
              },
              {
                "@type": "ListItem",
                "position": 6,
                "item": {
                  "@type": "Product",
                  "name": "eSteer 20",
                  "description": "10インチモニター・RTK±2.5cm精度・0.1-30km/h対応・クラシック/プロフェッショナルモード切替・ISOBUS対応。中小規模農場向け。価格お問い合わせ。",
                  "brand": {
                    "@type": "Brand",
                    "name": "EFIX"
                  },
                  "image": "https://ids-group.jp/images/esteer-20.jpg",
                  "offers": {
                    "@type": "Offer",
                    "price": 0,
                    "priceCurrency": "JPY",
                    "priceValidUntil": "2026-12-31",
                    "availability": "https://schema.org/InStock",
                    "seller": {
                      "@type": "Organization",
                      "name": "IDS教習所グループ",
                      "url": "https://ids-group.jp",
                      "telephone": "+81952719855"
                    }
                  }
                }
              }
            ]
          }
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "ホーム",
              "item": `${siteUrl}/`
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "自動操舵システム",
              "item": `${siteUrl}/auto-steering`
            }
          ]
        }
      ]
    }
  };

  useSEO(seoData);

  useEffect(() => {
    const h1 = document.createElement('h1');
    h1.textContent = '自動操舵システム';
    h1.style.position = 'absolute';
    h1.style.left = '-9999px';
    h1.style.fontSize = '1px';
    document.body.appendChild(h1);

    return () => {
      if (document.body.contains(h1)) {
        document.body.removeChild(h1);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <AutoSteeringHeroSection />
        <AutoSteeringLineupSection />
        <ManufacturerSection />
        <ComparisonTableSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
